// extracted by mini-css-extract-plugin
module.exports = {"related":"styles_related__362CS"};